export default [

  // PRODUCTION
  {
    path: '/workshop/production/list',
    name: 'workshop-production-list',
    component: () => import('@/views/workshop/production/production-list/ProductionList.vue'),
    meta: {
      pageTitle: 'Produksi',
      breadcrumb: [
        {
          text: 'Produksi',
          to: { name: 'workshop-production-list' },
          active: true,
        },
      ],
      resource: 'workshop-production-list',
      action: 'read',
    },
  },
  // STOCK
  {
    path: '/workshop/stock/list',
    name: 'workshop-stock-list',
    component: () => import('@/views/workshop/stocks/stock-list/StockList.vue'),
    meta: {
      pageTitle: 'Manajemen Stok',
      breadcrumb: [
        {
          text: 'Manajemen Stok',
          to: { name: 'workshop-stock-list' },
          active: true,
        },
      ],
      resource: 'workshop-stock-list',
      action: 'read',
    },
  },
]
